// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgWeekScheduleIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path
      fillRule="evenodd"
      d="M22 20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V10h20zm-10-8a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h3a1 1 0 1 0 0-2h-2v-2a1 1 0 0 0-1-1"
      clipRule="evenodd"
    />
    <path d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2H2z" />
    <path d="M9 5a1 1 0 0 1-2 0V3a1 1 0 0 1 2 0zm8 0a1 1 0 1 1-2 0V3a1 1 0 1 1 2 0z" />
  </g>
);
export default SvgWeekScheduleIcon;
SvgWeekScheduleIcon.displayName = 'SvgWeekScheduleIcon';
